// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBM_Plex_Mono_3488bc', '__IBM_Plex_Mono_Fallback_3488bc'","fontWeight":400,"fontStyle":"normal"},"className":"__className_3488bc"};